import React from "react"
import Select from "./Select"
import {MenuItem} from "@material-ui/core"
import { useTranslation } from "react-i18next"


const ImprovedEnum = ({...props}) => {
    const {t} = useTranslation()

    return(
        <Select {...props}>
        {props.typeParams.map((param:any) => <MenuItem key={param.key} value={param.key}>{ t(`/common:${param.label}`) }</MenuItem>)}
      </Select>
    )
}

export default ImprovedEnum